import React from "react";
import ErrorDisplay from "@directv-digital/dds.ui.error-display";
import DtvBox from "@directv-digital/dds.ui.dtv-box";
import ComparePackagesTray, { ComparePkgTrayProvider } from "../ComparePackageTray";
import { FlipCardsProps } from "./flip-cards.props";
import DtvText from "@directv-digital/dds.ui.dtv-text";
import FlipCards from "./components/FlipCards";

const styles = {
  rootContainerStyles: {
    display: "flex",
    flexDirection: "column"
  },
  titleStyles: {
    textAlign: "center",
    m: {
      xs: "0 20px 32px",
      sm: "64px 31px 32px",
      md: "64px 140px 64px 140px"
    }
  }
};
const FlipCardsContent = (props: FlipCardsProps) => {
  const { background, cards, title, config, comparePkgTray } = props;
  if (!Array.isArray(cards) || cards.length === 0) {
    return null;
  }
  try {
    return (
      <DtvBox sx={{
 background,
...styles.rootContainerStyles
}}>
        {title?.content && <DtvText {...title} sx={styles.titleStyles} />}
        <FlipCards cards={cards} config={config} />
        {comparePkgTray && <ComparePackagesTray {...comparePkgTray} originType="packageCarousel" enableSectionToggle />}
      </DtvBox>
    );
  } catch (error) {
    return <ErrorDisplay component="FlipCards" error={error} />;
  }
};
const FlipCardsModule = (props: FlipCardsProps) => {
  if (!props) {
    return null;
  }
  return (
    <ComparePkgTrayProvider
      compareText={props?.comparePkgTray?.compareText || ""}
      isComparePkgTray={!!props?.comparePkgTray?.isCompareEnabled}
      maxSelectedTag={Number(props?.comparePkgTray?.maxSelectedPackages) || 3}
    >
      <FlipCardsContent {...props} />
    </ComparePkgTrayProvider>
  );
};

export default React.memo(FlipCardsModule);
